
/* Taken from https://github.com/syropian/vue-tribute */
import {Component, Vue, Prop} from 'vue-property-decorator'
import Tribute from 'tributejs'

@Component({})
export default class VueMention extends Vue {
  @Prop({type: Object, required: true}) public options!: any

  public tribute: any

  public mounted() {
    const $el = this.$slots.default[0].elm

    this.tribute = new Tribute(this.options)
    this.tribute.attach($el)

    if ($el !== undefined) {
      $el.addEventListener('tribute-replaced', (e) => {
        this.$emit('tribute-replaced', e)
      })

      $el.addEventListener('tribute-no-match', (e) => {
        this.$emit('tribute-no-match', e)
      })
    }
  }

  public render(h: any) {
    return h(
      'div',
      {
        staticClass: 'v-tribute',
      },
      this.$slots.default,
    )
  }
}
